<template>
  <div>
    <table
      class="mt-3 mb-1 table table-striped table-bordered table-sm"
      style="width:100%;font-size:.9rem;"
    >
      <thead>
        <tr>
          <th v-if="isOpen" class="align-middle text-center text-success cursor-pointer"
            rowspan="2" title="Aggiungi componente" @click="apriForm()">
            <font-awesome-icon icon="plus" class="cursor-pointer text-success"/>
            <br>(*)
          </th>
          <th class="align-middle text-center">Nome</th>
          <th class="align-middle text-center">Cognome</th>
          <th class="align-middle text-center">Data di nascita</th>
          <th class="align-middle text-center">Codice Fiscale</th>
          <th class="align-middle text-center">% disabilità</th>
          <th class="align-middle text-center">Parentela</th>
          <th class="align-middle text-center">Data decesso</th>
          <th class="align-middle text-center">Residente o appartenente dal/al</th>
          <th class="align-middle text-center">Redditi da pensione</th>
          <th class="align-middle text-center">Redditi da lavoro dipendente</th>
          <th class="align-middle text-center">Redditi da lavoro autonomo</th>
          <th class="align-middle text-center">Altri redditi</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(r,idx) in rows" :key="idx" :style="'background-color:' + didascaliaOrigineSoggetto(r.origineSoggetto)" >
          <td v-if="isOpen" class="align-middle text-center text-success" title="Modifica componente" @click="apriForm(idx)">
            <font-awesome-icon icon="pen" class="cursor-pointer text-success"/>
          </td>
          <td class="align-middle text-nowrap">{{ r.nome }}</td>
          <td class="align-middle text-nowrap">{{ r.cognome }}</td>
          <td class="align-middle text-nowrap">{{ r.dataNascita ? moment(r.dataNascita).format('DD/MM/YYYY') : '' }}</td>
          <td class="align-middle text-nowrap">{{ r.codiceFiscale }}</td>
          <td class="align-middle text-center text-nowrap">{{ r.percDisabilita }} {{ r.percDisabilita ? '%' : '-' }}</td>
          <td class="align-middle text-nowrap">{{ r.tipoComponente }}</td>
          <td class="align-middle text-nowrap">{{ r.dataDecesso ? moment(r.dataDecesso).format('DD/MM/YYYY') : '' }}</td>
          <td class="align-middle text-nowrap">
            <div class="d-flex flex-column">
              <span v-if="r.nonResidente && r.nonResidente === 'true'" class="mb-1">Non residente</span>
              <span>{{ r.residenteDal ? moment(r.residenteDal).format('DD/MM/YYYY') : '' }}</span>
              <span>{{ r.residenteAl && r.residenteAl != '9999-12-31' ? moment(r.residenteAl).format('DD/MM/YYYY') : '' }}</span>
            </div>
          </td>
          <td class="align-middle text-right text-nowrap">{{ numeral(r.redditiPensione || 0).format() }} €</td>
          <td class="align-middle text-right text-nowrap">{{ numeral(r.redditiDipendente || 0).format() }} €</td>
          <td class="align-middle text-right text-nowrap">{{ numeral(r.redditiAutonomo || 0).format() }} €</td>
          <td class="align-middle text-right text-nowrap">{{ numeral(r.redditiAltri || 0).format() }} €</td>
        </tr>
        <tr v-if="!rows || !rows.length">
          <td :colspan="!isOpen ? '11' : '12'" class="text-center font-italic">Nessun componente dichiarato</td>
        </tr>
      </tbody>
    </table>

    <div class="small text-left">
      (*) Origine componente nucleo familiare
      <template v-for="(o,idx) in originiSoggetto" >
        <b :key="idx"> -
          <span :style="'background-color:' + didascaliaOrigineSoggetto(o.value)" > {{o.text}};</span>
        </b>
      </template>
    </div>

    <reddito-modal ref="modal" />
  </div>
</template>

<script>
import numeral from 'numeral'
import moment from 'moment'
import RedditoModal from '@/components/RedditoModal'

export default {
  name: 'RedditiTable',
  components: {
    RedditoModal
  },
  props: {
    item: { type: Object, required: true },
    originiSoggetto: { type: Array, required: true }
  },

  computed: {
    numeral () {
      return numeral
    },
    moment () {
      return moment
    },
    isOpen () {
      // return this.item.stato === 'A'
      // console.log('(Redditi) Se dichiarazione P o B: ', this.item.stato, this.item.stato === 'B' || this.item.stato === 'P')
      return this.item.stato === 'B'
      // return this.item.stato === 'B' || this.item.stato === 'P'
    },
    rows () {
      return this.item.redditi
    }
  },

  methods: {
    apriForm (idx) {
      this.$refs.modal.open({ item: this.item, idx })
    },
    didascaliaOrigineSoggetto (value) {
      let idRet = null
      // console.log('didascaliaOrigineSoggetto', this.originiSoggetto, value)
      if (!value) value = 'NU'
      idRet = this.originiSoggetto && value ? this.originiSoggetto.find(x => x.value === value).color || 'red' : 'red'
      // console.log('didascaliaOrigineSoggetto', idRet, value)
      return idRet
    }
  }
}
</script>
